import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../../../shared/utils/helpers';

const mutation = graphql`
  mutation ActivateReleaseMutation($input: ActivateReleaseInput!) {
    activateRelease(input: $input) {
      updatedRelease {
        id
        isActive
      }
    }
  }
`;

const ActivateReleaseMutation = (id, callback) => {
  const config = {
    mutation,
    variables: { input: { id } },
    onCompleted: response => {
      callback(response.activateRelease);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default ActivateReleaseMutation;
